import {
  Box,
  Button,
  Flex,
  HStack,
  ListItem,
  UnorderedList,
} from '@chakra-ui/react'
import React from 'react'

import { Pill } from '~shared-components/components/Pill/Pill'
import { useTranslations } from '~shared-components/hooks/useTranslations'
import { IconUser } from '~shared-components/icons/brand/IconUser'
import BrenntagConnectLogo from '~shared-components/theme/svgs/brenntag-connect-logo.svg'

import { RouterButton, RouterLink } from '../RouterLink/RouterLink'
import Cart from './Cart'
import { HeaderProps } from './Header'

const sxButtonStyle = {
  display: 'flex',
  height: 'auto',
  padding: 0,
  textDecoration: 'none',
}

const sxNavStyle = {
  a: {
    padding: '17px 16px 18px',
    position: 'relative',
    transition: 'background-color 0.15s ease-out',
  },
  'a.active': {
    '&:after': {
      bgGradient: `linear(to-r, violet.50, blue.50)`,
      bottom: 0,
      content: '""',
      height: '4px',
      left: 0,
      position: 'absolute',
      width: '100%',
    },
    fontWeight: 'bold',
  },
  'a:active': {
    bg: 'blue.30',
  },
  'a:hover': {
    '&:not([class="active"]):after': {
      bg: 'blue.40',
      bottom: 0,
      content: '""',
      height: '4px',
      left: 0,
      position: 'absolute',
      width: '100%',
    },
    bgColor: 'blue.80',
  },
}

const sxSvgStyle = {
  svg: {
    color: 'neutral.90',
    display: 'block',
    fill: 'neutral.90',
  },
}

const DesktopHeader = ({
  cartLink,
  environmentTag,
  homeLink,
  isCsrUi,
  isLoggedIn,
  onLogout,
  profileLink,
  search,
  topMenuLinks,
}: HeaderProps) => {
  const t = useTranslations()
  return (
    <Flex
      bgColor="white"
      display={['none', 'none', 'initial']}
      flexDirection="column"
      py="1px"
      zIndex="100"
    >
      <Box px={['20px', '50px', '80px']}>
        <Flex
          alignItems="center"
          justifyContent="space-between"
          margin="15px 0 16px"
          sx={sxSvgStyle}
        >
          <HStack alignItems="center" spacing={[2, 3, 5]}>
            <RouterLink to={homeLink}>
              <Box float="left">
                <BrenntagConnectLogo />
              </Box>
            </RouterLink>
            {isCsrUi && (
              <Pill bgColor="deepPurple" variant="chip-solid">
                Admin interface
              </Pill>
            )}
            {environmentTag}
          </HStack>
          {search}
          <HStack alignItems="center" flexDirection="row" spacing={[2, 3, 5]}>
            {profileLink && (
              <RouterButton
                leftIcon={<IconUser boxSize="16px" />}
                sx={sxButtonStyle}
                to={profileLink}
                variant="text"
              >
                {t('label.myprofile')}
              </RouterButton>
            )}
            {isLoggedIn &&
              (onLogout ? (
                <Button onClick={onLogout} sx={sxButtonStyle} variant="text">
                  {t('label.logout')}
                </Button>
              ) : (
                <a href="/logout">{t('label.logout')}</a>
              ))}
            {cartLink && <Cart cartLink={cartLink} />}
          </HStack>
        </Flex>
      </Box>
      <Box
        alignItems="stretch"
        as="nav"
        bg="deepPurple"
        pb="15px"
        pt="15px"
        px={['20px', '50px', '80px']}
      >
        <UnorderedList m={0} role="navigation" sx={sxNavStyle}>
          {topMenuLinks.map((topLink, index) => (
            <ListItem
              key={index}
              color="white"
              display="inline-block"
              fontWeight="bold"
              listStyleType="none"
            >
              {topLink}
            </ListItem>
          ))}
        </UnorderedList>
      </Box>
    </Flex>
  )
}
export default DesktopHeader
